<template>
  <div class="wrapper">
    <el-form ref="formData" :model="formData" :rules="rules" label-width="150px">
      <el-form-item prop="issueId" label="贷款编码">
        <el-input v-model="formData.issueId" disabled />
      </el-form-item>
      <el-form-item prop="driverName" label="收款人">
        <el-input v-model="formData.driverName" disabled />
      </el-form-item>
      <el-form-item prop="driverAmt" label="收款金额(元)">
        <el-input v-model="formData.driverAmt" disabled />
      </el-form-item>
      <template v-if="formData.isWsShare==1">
        <el-form-item prop="driverLeaderName" label="车队长">
          <el-input v-model="formData.driverLeaderName" disabled />
        </el-form-item>
        <el-form-item prop="leaderAmt" label="车队长金额(元)">
          <el-input v-model="formData.leaderAmt" disabled />
        </el-form-item>
      </template>
      <div style="text-align:left">
        <el-button type="primary" @click="onSubmit">确 认</el-button>
        <el-button @click="funcCancel">取 消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>

  import request from '@/utils/request'
  export default {
    data(){
      return {
        code:'',
        formData:{
          isWsShare:0,
          issueId:'',
          driverAmt:'',
          leaderAmt:'',
          driverName:'',
          driverLeaderName:'',
          bankCardNo:'',
          branchName:'',
          LeaderBankCardNo:'',
          LeaderBranchName:''
        },
        rules:{
        }
      }
    },
    created(){
    },
    methods:{
      async getInfo(code){
        this.code=code;
        request({
          url: '/ntocc-tms-api/creditProof/cashOut/Detail',
          method: 'get',
          params: {code:code}
        }).then((response) => {
          this.formData = response.data
        }).catch(() => {
          this.$refs["formData"].resetFields();
          this.$emit("fatherLoanMethod");
        });
      },
      onSubmit(){
        this.$refs['formData'].validate(valid => {
          if (valid) {
            const rLoading = this.openLoading();
            request({
              url: '/ntocc-tms-api/creditProof/cashOut',
              method: 'get',
              params: {code:this.code}
            }).then(response => {
              rLoading.close();
              if(response.status == '0'){
                this.$message({
                  message: response.msg,
                  type: "success"
                });
              }else{
                this.$message({
                  message: response.msg,
                  type: "error"
                });
              }
            }).finally(() => {
              this.$refs["formData"].resetFields();
              this.$emit("fatherLoanMethod");
            });
          } else {
            return false;
          }
        });
      },
      // 取消
      funcCancel() {
        this.$emit("fatherCancelMethod", "loan");
      }
    },
  }
</script>
<style scoped lang='scss'>
</style>
